import { Skeleton } from "@mantine/core"

import { useFindCertificateById } from "~/gen/api"
import { CertificateViewer } from "~/pages/SupplierPortal/TraceabilityRequests/components/CertificateViewer"

interface Props {
  certificateId: string
}

export const CertificateViewerById = ({ certificateId }: Props) => {
  const {
    data,
    isPending: isLoading,
    isError,
  } = useFindCertificateById(certificateId)

  if (isLoading) {
    return <Skeleton />
  }

  if (isError) {
    return <div>Error</div>
  }

  return <CertificateViewer certificate={data.data} />
}
